export enum ModerationRuleType {
	Forbidden = 0,
	Suggestion = 1,
}

export enum ModerationRulePromptType {
	Positive = 0,
	Negative = 1,
	All = 2,
}

export interface ModerationRule {
	readonly in: ReadonlyArray<string>
	readonly out: ReadonlyArray<string>
	readonly prompt: ModerationRulePromptType
	readonly type: ModerationRuleType
}

export interface ModerationError<T> {
	type: ModerationRuleType
	words: T
	suggestions?: T
}
